'use strict';

var EFC = window.EFC = (window.EFC || {});
EFC.SmoothScroll = (function($) {
  function init() {
    enableFor('.smoothscroll');
  }
  
  function enableFor(selector) {
    document.querySelectorAll(selector).forEach(anchor => {
      const target = anchor.getAttribute('href');
      const targetEl = document.getElementById(target.substring(1));

      // Special case: the header overlays the top of the screen, and our normal CSS tricks won't work to 
      // extend the #main element higher to make it work.
      const isMain = (target === '#main');
      
      if (!isMain) {
        targetEl && targetEl.classList.add('smoothScroll__target');
      }
      
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        
        if (isMain) {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
        else {
          targetEl && targetEl.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  };
  
  $(init);
})(jQuery);